import ViewModel from './asset-dashboard.vm';
import moment from 'moment';
import Auth from '../../auth';

const chrome = {
  name: 'Google Chrome',
  icon: 'fa-chrome',
  url: 'https://www.google.com/chrome/',
};

const firefox = {
  name: 'Mozilla Firefox',
  icon: 'fa-firefox',
  url: 'https://www.mozilla.org/en-US/firefox/new/',
};

const edge = {
  name: 'Microsoft Edge',
  icon: 'fa-edge',
  url: 'https://www.microsoft.com/en-ca/software-download/windows10',
};

const getBrowserSupportList = (browser) => {
  const browserList = [chrome, firefox];

  if (browser.osname === 'Windows' && browser.osversion === '10') {
    browserList.push(edge);
  }

  return browserList;
};

class AssetDashboardController {
  constructor(
    equipmentDetailsService,
    $stateParams,
    browser,
    $interval,
    dashboardCommandsService,
    usersService,
  ) {
    'ngInject';

    this.model = {};
    this.loading = true;
    this.browser = browser;
    this.newBrowsers = getBrowserSupportList(browser);
    const equipmentId = $stateParams.equipmentId;
    this.equipmentDetailsService = equipmentDetailsService;
    this.commandService = dashboardCommandsService;
    this.usersService = usersService;
    this.$interval = $interval;
    this.active = true;

    this.fetchEquipment(equipmentId);
  }

  fetchEquipment(equipmentId) {
    this.refreshing = true;
    this.equipmentDetailsService
      .get(equipmentId, [
        'series',
        'alerts',
        'series.sparklines',
        'maintenancePlans',
        'faults',
        'attributes',
        'deviceCommands',
      ])
      .then((equipment) => {
        //to avoid using incomplete data where the call returns 200 but some part of the call is empty due to token expiration
        if (this.model && !this.active) return;

        this.model = new ViewModel(equipment);

        this.series = equipment.onei3.series;
        const { commands, total } = this.commandService.getSupportedCommands(
          equipment,
          this.model.packageIds,
        );

        this.commands = commands;
        this.showCommands =
          total > 0 && this.usersService.hasRequiredFeatures(['commands.control']);
      })
      .catch((err) => {
        //to prevent the UI from showing the error in case the toke expired while the API call still in progress and returned error.
        if (this.active) {
          this.error = err;
          throw err;
        }
      })
      .finally(() => {
        this.loading = this.refreshing = false;
      });
  }

  getDashboardLifetime() {
    const expiryAt = Auth.getExpiry();
    this.expiryDate = moment.unix(expiryAt);
    this.expiryIn = moment(this.expiryDate).diff(moment(), 'seconds');

    this.dashboardLifetimecheck();
  }

  dashboardLifetimecheck() {
    this.timeCheckInterval = this.$interval(() => {
      this.secondsLeft = moment(this.expiryDate).diff(moment(), 'seconds', true);
      this.timeInMins = Math.ceil(this.secondsLeft / 60.0);

      if (this.secondsLeft < 1) {
        this.active = false;
        this.secondsLeft = -1;
        this.timeInMins = '';
        this.$interval.cancel(this.updateAssetInterval);
        this.$interval.cancel(this.timeCheckInterval);
      }
    }, 500);
  }

  $onInit() {
    this.getDashboardLifetime();
    this.updateAssetInterval = this.setRefreshInterval();
  }

  $onDestroy() {
    this.$interval.cancel(this.updateAssetInterval);
    this.$interval.cancel(this.timeCheckInterval);
  }

  setRefreshInterval() {
    return this.$interval(() => {
      //making sure not to fire another call when there is one in progress
      if (!this.refreshing) {
        this.fetchEquipment(this.model.id);
      }
    }, 5000); //5 sec
  }

  timeAgo(time) {
    return moment(time).fromNow();
  }

  toggelCommandsView() {
    this.showCommandsView = !this.showCommandsView;
  }
}

export default {
  template: require('./asset-dashboard.html'),
  controller: AssetDashboardController,
  bindings: {},
  controllerAs: 'vm',
};
